export interface LoginRequest {
  username?: string;
  password?: string;
  rememberMe?: boolean;
}
